const initState = {
    isExpired: false,
    isLoading: true,
    gate: {},
    date: new Date(),
    guest: {}
};

const userReducer = (state = initState, action) => {
    switch(action.type){
        case 'SET_GUEST':
            return {
                ...state,
                guest: action.guest,
            };
        case 'GUEST_EXPIRE':
            return {
                ...state,
                isExpired: true,
                isLoading: false
            };
        case 'GUEST_GATE':
            return {
                ...state,
                gate: action.gate,
                isLoading: false
            }
        case 'GUEST_DATE':
            return {
                ...state,
                date: action.date
            }  
        default:
            return state;
    }
};

export default userReducer;